import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Hook that returns true if the device on which it is called is a mobile device
 *
 * Passes `noSsr: true` to `useMediaQuery` -- without it, MUI returns a hardcoded `false` on the
 * very first render (an SSR-hydration safeguard this CRA app doesn't need) and only corrects to
 * the real value after mount. Existing "conditional UI" consumers of this hook (nav links,
 * padding) tolerate that one-render flicker invisibly; a consumer that makes an immediate,
 * synchronous routing decision off the first render -- e.g. redirecting away in a mobile-only
 * route guard -- does not, and would incorrectly redirect on every fresh mount even on an
 * actual mobile device.
 * @returns True if the device rendering the page has a mobile-size screen
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"), { noSsr: true });
  return matches;
}

export default useIsMobile;
